export default "__VITE_ASSET__DAUdSQ9X__"